"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PROXY_API = {
    POST: {
        API_AUTHORITY: '/authority',
        SIGNUP_REQUEST: {
            BASE: 'user/signuprequest',
            WITH_TAN: 'user/signuprequest/:tanKey',
            RESEND_NOTIFICATION: '/signuprequest/:tan/:rowKey/resendnotification',
        },
        USER: {
            ROLE: '/user/role/:tan',
            REMOVAL_REQUEST: '/user/:tan/removal',
        },
        VT_USER: {
            REGISTRATION: '/vt-user/registration',
            CONFIRM_TOKEN: '/vt-user/token',
        },
        SUPPORT_TICKET: 'cms/support/ticket',
        VERIFY_TOKEN: '/verifytoken',
        CONTACTS: {
            VEHICLE_CONTACTS: '/vehicle/contact',
            FLEET_CONTACTS: '/fleet/contact/:tan',
        },
        VEHICLE: {
            TAGS_TAN: '/vehicle/:tan/customTags',
            UNITID_ANALYSIS_TAN: '/vehicle/:tan/unitId/analysis',
            UNITID_BULK: '/vehicle/:tan/unitId',
        },
        PARAMETER_PROFILES: {
            CREATE: '/profiles/create',
        },
        FIRMWARE: {
            ECUSUMMARIES: '/ecusummaries',
            VEHICLES_WITH_ECUSUMMARIES: '/vehicleswithecu',
            APPROVE_CAMPAIGNS: '/dispatch/create',
        },
        DDEC: {
            DISPTACH_OTA_DDEC: '/ota/create',
        },
        FAULT: {
            SHARE_FAULT_EVENT_BY_EMAIL: '/fault/v1/global/fault/shareFaultEventByEmail/:streamingSource/:rowKey',
        },
        CUSTOMER_CONTACT: {
            WITH_TAN: 'customer/contact/:tan',
        },
    },
    GET: {
        CUSTOMER: {
            SEARCH: 'customer/search?name=:name&tanKey=:tanKey',
            WITH_TAN: 'customer/:tan',
            PRINCIPAL: 'customer/principal',
        },
        CUSTOMER_CONTACT: {
            WITH_TAN: 'customer/contact/:tan',
        },
        DEALER: {
            BASE: 'dealer?longitude=:longitude&latitude=:latitude&limit=:limit',
            CODE: 'dealer/code?codes=:code',
        },
        FUEL: {
            SEVERITY_DATA: 'fuel/severitydata',
            POPULATION_DATA: 'fuel/population/tan/:tan',
        },
        FAULT: {
            FAULT_SEARCH: '/fault/v1/global/fault?faultSearchCriteria&tan=:tan',
            /** @deprecated use EVENT_BY_STREAMING_SOURCE_AND_ID */
            EVENT_BY_ROWKEY: '/fault/:rowKey',
            EVENT_BY_STREAMING_SOURCE_AND_ID: '/fault/v1/global/fault/:streamingSource/:rowKeyOrFaultId',
            /** @deprecated use EVENT_BY_STREAMING_SOURCE_AND_EVENT_ID OR VT_EVENT_BY_ID in case of VT call */
            EVENT_BY_EVENTID: '/fault/event/:eventId',
            VT_EVENT_BY_ID: '/fault/v1/global/fault/vt/event/:eventId',
            EVENT_BY_STREAMING_SOURCE_AND_EVENT_ID: '/fault/v1/global/fault/event/:streamingSource/:eventId',
            TAN_EVENT_BY_RINGBUFFER_ROWKEY: '/fault/ringbuffer/:tan/:rowKey',
            TAN_EVENT_BY_RINGBUFFER_ROWKEY_AND_FAULT_OBSERVATION: '/fault/v1/global/fault/ringbuffer/:tan/:vin/:sa/:spn/:fmi?activeFaultObservationStartTime=:activeFaultObservationStartTime', // for gvh events
        },
        PASSWORD_REGEXP: 'user/signuprequest/password',
        PERMISSIONS: 'user/permissions',
        NOTIFICATIONS_SAFETY_EVENTS: {
            SETTINGS_TAN: '/notifications/safetyevents/:tan',
            SETTINGS_TAN_AND_SAFETY_EVENT: '/notifications/safetyevents/:tan/:safetyevent',
        },
        SAFETY_EVENTS: {
            FLEET_WIDE_VIEW_TAN: '/analytics/safety/fleetWideView/:tan',
            RING_BUFFER_DATA: '/analytics/safety/SafetyRingBufferEvent/:vin/:timestamp/:inMeter',
            SAFETY_EVENTS_DAYS: '/analytics/safety/safetyevents/:tan/:vin/:days/:inMeter',
        },
        SAFETY_FEATURES: {
            FLEET_DATA_TAN: 'analytics/safetyFeatures/fleet/status/:tan',
            VEHICLE_VIEW_VIN: 'analytics/safetyFeatures/status/vehicle/:tan/:vin',
        },
        NOTIFICATIONS_SAFETY_SYSTEMS: {
            SETTINGS_TAN: '/notifications/safetysystems/:tan',
        },
        NOTIFICATION_SETTINGS: {
            SEVERITY: 'notification/settings/severity/:tan',
            INDIVIDUAL: 'notification/settings/individual/:tan',
            INDIVIDUAL_CSV: 'notification/settings/individualcsv/:tan',
        },
        TERMS: 'cms/support/accounts/terms/:country',
        USER: {
            USERS_LIST: '/user/:tan',
            PRINCIPAL: '/user/:tan/principal',
            CLAIMS: '/user/claims',
            ROLES_LIST: '/user/role/:tan',
            ROLE: '/user/role/:tan/:rowKey',
            TERMS_OF_USE: '/user/terms-of-use',
        },
        SIGNUP_REQUEST: {
            WITH_TAN: '/signuprequest/:tan',
        },
        VT_USER: {
            PREFLIGHT_CHECK: '/vt-user/preflight-check?id=:id',
        },
        VEHICLE: {
            MAINTENANCE_TAN: '/vehicle/:tan/maintenance?pkgMaintenanceSystem=true',
            VEHICLES_BY_TAN: '/vehicle/:tan/getVehiclesByTan',
            VTDASH_SEARCH_BY_VIN_OR_SERIAL: '/vehicle/:vin',
            SEARCH_BY_TAN_AND_VIN: '/vehicle/:tan/list',
        },
        VEHICLE_INFO: '/vehicle/:tan/:vin/info',
        VEHICLE_BRIEFINFO: '/vehicle/:tan/briefInfo',
        GPS_WITH_TAN_VIN: '/gps/:tan/:vin',
        GPS_WITH_TAN_VIN_LATEST: '/gps/:tan/:vin/latest',
        VEHICLES_LIST_PAGE_TAN: '/vehicle/:tan/status',
        PRODUCT: {
            NAMES: '/product/names',
        },
        CONTACTS: {
            VEHICLE_CONTACTS: '/vehicle/contact/:tan',
            FLEET_CONTACTS: '/fleet/contact/:tan',
        },
        WIDGETS_DASHBOARD: {
            FLEET_DEMOGRAPHICS: '/health/:tan/fleetdemographics',
            FLEET_PERFORMANCE: '/health/:tan/faultPerformance',
            FLEET_SUMMARY_BY_MONTH: '/health/months/:tan/fleetsummarybymonth',
            FLEET_TOP_SERVICE_NOW: '/health/:tan/topservicenow',
        },
        PARAMETER_PROFILES: {
            GET_PARAMETER_PROFILES: '/profiles/:tan',
            GET_POTA_VEHICLES: '/profiles/:tan/vehicles',
            GET_POTA_VEHICLES_CSV: '/profiles/:tan/vehicles/csv',
        },
        DDEC: {
            GET_OTA_DDEC_STATUS: '/ota/status/:tan/:vin',
            GET_DDEC_CABLE_CONNECTED_XTR_FILE: '/cc/download/:tan/:vin/:timestamp',
            GET_DDEC_OVER_THE_AIR_XTR_VIN_OPERATION_ID: '/ota/download/:tan/:vin/:operationId',
            GET_CC_DDEC_LIST: '/cc/list/:tan/:vin',
            GET_CC_DDEC_PREVIEW_REPORT: '/cc/preview/:tan/:vin/:timestamp',
            GET_OTA_DDEC_PREVIEW_REPORT: '/ota/preview/:tan/:vin/:operationid',
        },
        SIGN_IN: {
            CODE: 'signin/code',
            REFRESH_TOKEN: 'signin/refreshtoken',
        },
        FIRMWARE: {
            CAMPAIGN: '/campaigns/consolidated',
        },
        VRC: {
            GET_LOCK_UNLOCK_HISTORICAL_DATA: '/vrc/historical/:tan/:vin/:startTimestamp/:endTimestamp',
            GET_LOCK_STATUS: '/vrc/lock/status/:tan/:vin',
            GET_UNLOCK_STATUS: '/vrc/unlock/status/:tan/:vin',
        },
        HEREMAP: {
            TOKEN: '/heremaps/token',
        },
    },
    PUT: {
        USER: {
            PROFILE: '/user',
            ROLE: '/user/role/:tan/:rowKey',
            TERMS_OF_USE_VERSION: '/user/terms-of-use/:version',
        },
        NOTIFICATIONS_SAFETY_EVENTS: '/notifications/safetyevents',
        NOTIFICATIONS_SAFETY_SYSTEMS: '/notifications/safetysystems',
        NOTIFICATION_SETTINGS: {
            SEVERITY: 'notification/settings/severity/:tan',
            INDIVIDUAL: 'notification/settings/individual/:tan',
        },
        TERMS: 'cms/support/accounts/terms',
        UPDATE_CUSTOMER_WITH_TAN: 'customer/:tan',
        SIGNUP_REQUEST: {
            UPDATE: '/signuprequest/:tan/:rowKey',
        },
        CONTACTS: {
            VEHICLE_CONTACTS: '/vehicle/contact',
            FLEET_CONTACTS: '/fleet/contact/:tan',
        },
        VEHICLE: {
            UNITID: '/vehicle/:tan/unitId',
        },
        PARAMETER_PROFILES: {
            UPDATE_PROFILE_TO_VEHICLES: '/profiles/update/vehicles',
            UPDATE_PARAMETER_PROFILES: '/profiles/update',
            ASSIGN_PROFILE_TO_VEHICLES: '/profiles/:tan',
        },
        VRC: {
            LOCK_DOORS: '/vrc/lock/:tan/:vin',
            UNLOCK_DOORS: '/vrc/unlock/:tan/:vin',
        },
        CUSTOMER_CONTACT: {
            WITH_TAN: 'customer/contact/:tan',
        },
        SUBSCRIPTIONS: {
            REMOVE_VEHICLES: '/cms/account/vehicle',
        },
    },
    PATCH: {
        SIGNUP_REQUEST: 'user/signuprequest',
        USER_ROLES: '/user/role/:tan/:id',
        FAULT: {
            TAN_UPDATE_FLAG_RESOLVE: '/fault/:tan/updateFlagResolve',
        },
    },
    DELETE: {
        USERS: {
            TAN_USERS_ROWKEY: '/user/:tan/:rowKey',
            ROLE_ROWKEY: '/user/role/:tan/:rowKey',
        },
        SIGNUP_REQUEST: {
            DELETE: '/signuprequest/:tan/:rowKey',
        },
        CONTACTS: {
            VEHICLE_CONTACTS: '/vehicle/contact/:tan/:email',
            FLEET_CONTACTS: '/fleet/contact/:tan/:rowKey',
        },
        PARAMETER_PROFILES: {
            DELETE_PARAMETERS_PROFILE: '/profiles/:tan/:profileid',
        },
        DDEC: {
            DISCARD_CC_DDEC_REPORT: '/cc/delete/:tan/:vin/:timestamp',
            DISCARD_OTA_DDEC_REPORT: '/ota/delete/:tan/:vin/:operationId',
        },
        CUSTOMER_CONTACT: {
            WITH_TAN_ROW_KEY: 'customer/contact/:tan/:rowKey',
        },
    },
    RESPONSE_PARAMS: {
        USER_MODEL: 'UserModel',
        USER_TAN_CLAIM_MODEL: 'UserTanClaimModel',
    },
};
exports.default = PROXY_API;
